/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInventoryCount = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.47 2.152a1 1 0 0 1 1.06 0l8 5A1 1 0 0 1 21 8v4.825L19 14.7V9.804l-6 3.75v3.088l-2 2.134v-5.222l-6-3.75v5.642l5.752 3.595-.263.28 2.434 2.281-.393.246a1 1 0 0 1-1.06 0l-8-5A1 1 0 0 1 3 16V8a1 1 0 0 1 .47-.848zm.53 9.669L18.113 8 12 4.18 5.887 8zm4.667 10.55 6.017-5.641-1.368-1.46-4.65 4.36-1.982-1.86-1.368 1.46z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInventoryCount as InventoryCount };
